import { api } from "./api";

export interface SessionInfo {
  id: string;
  agent_instance_id: string;
  client_id: string | null;
  provider_id: string | null;
  user_id: string;
  title: string;
  status: string;
  model: string;
  last_active_at: string;
  created_at: string;
  adapter_type?: string;
  provider_name?: string;
}

export interface MessageInfo {
  id: string;
  session_id: string;
  role: string;
  content: string;
  metadata: Record<string, unknown>;
  created_at: string;
}

export const sessionService = {
  create: (agentId: string, title?: string) =>
    api.post<SessionInfo>("/sessions", { agent_id: agentId, title: title || "New Session" }),
  list: (agentId: string) =>
    api.get<SessionInfo[]>(`/agents/${agentId}/sessions`),
  get: (id: string) => api.get<SessionInfo>(`/sessions/${id}`),
  update: (id: string, data: { title?: string }) =>
    api.put<SessionInfo>(`/sessions/${id}`, data),
  delete: (id: string) => api.delete(`/sessions/${id}`),
  spawn: (id: string) => api.post<SessionInfo>(`/sessions/${id}/spawn`),
  kill: (id: string) => api.post<SessionInfo>(`/sessions/${id}/kill`),
  messages: (id: string, before?: string, limit?: number) =>
    api.get<{ messages: MessageInfo[]; has_more: boolean }>(
      `/sessions/${id}/messages?${before ? `before=${before}&` : ""}limit=${limit || 50}`
    ),
};
